import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  downloadFileApi,
  generateForm,
  docusign,
  submitRequest,
  handleOnlineSignature,
  handleDocusignResult,
  sendNotification,
} from "./FormsAPI";
import { AddressChangeInfo, BankChangeInfo, IFile, NameChangeInfo, POAInfo, PrefilledInfo } from "../interfaces";
import { RootState } from "./store";

export interface IFormsState {
  msg: string | null;
  err_msg: string | null;
  pdf: string | null;
  accessToken: string | null;
  formType: string | null;

  errors: string[] | null
}

export const formsState: IFormsState = {
  msg: null,
  err_msg: null,
  pdf: null,
  accessToken: null,
  formType: null,

  errors: null
};



export const handleDocusignResultsAction = createAsyncThunk(
  "handle_Docusign_Results_Acction",
  async (args: any) => {
    const response = await handleDocusignResult(args);
    return response;
  }
);

export const handleOnlineSignatureAcction = createAsyncThunk(
  "handle_Online_Signature_Acction",
  async (args: { info: PrefilledInfo | NameChangeInfo; blob: Blob; formType: string }) => {
    const response = await handleOnlineSignature(args);
    return response;
  }
);

export const generateFormAction = createAsyncThunk(
  "generateFormAction",
  async (args: {
    info: PrefilledInfo | AddressChangeInfo | BankChangeInfo | NameChangeInfo | POAInfo;
    files:IFile[];
    formType: string;
  }) => {
    const response = await generateForm(args);
    return response;
  }
);

export const submitRequestAction = createAsyncThunk(
  "submitRequestAction",
  async (args: { requestType: string; regNum: number; prefilledInfo: PrefilledInfo }) => {
    const response = await submitRequest(args);
    return response;
  }
);

export const docusignAction = createAsyncThunk(
  "docusignAction",
  async (args: {
    country: string;
    regNum: number;
    fund: string;
    formType: string;
    firstName: string;
    lastName: string;
    email: string;
    dob: Date;
    accountId: number;
    requestId: number | undefined;
    claimEmail: string |null
  }) => {
    const data = await docusign(args);
    return data;
  }
);

export const downloadFormAction = createAsyncThunk(
  "downloadForm",
  async (args: { regNum: number; formType: string; fund: string | undefined; bank_country?: string }) => {
    const response = await downloadFileApi(args);
    return response;
  }
);

export const sendNotificationAcction = createAsyncThunk(
  "sendNotificationEmail",
  async (args: { fund: string; firstName: string; lastName: string; regNum: number; country: string }) => {
    const response = await sendNotification(args);
    return response;
  }
);

export const FormsSlice = createSlice({
  name: "FormsSlice",
  initialState: formsState,
  reducers: {
    setFormMsg: (state, action: PayloadAction<string | null>) => {
      state.msg = action.payload;
    },
    setFormErrMsg: (state, action: PayloadAction<string | null>) => {
      state.err_msg = action.payload;
    },

    setFormType: (state, action: PayloadAction<string | null>) => {
      state.formType = action.payload;
    },


  },
  extraReducers: (builder) => {
   

    builder.addCase(handleOnlineSignatureAcction.pending, (state) => {})
   .addCase(handleOnlineSignatureAcction.fulfilled, (state, action: PayloadAction<any | null>) => {
      const { result, msg } = action.payload;
      if (!result) {
        const msg =
          action.payload.msg === "Token authorization is failed."
            ? "The seasion has expiried. Please refresh the page or login"
            : action.payload.msg;
        state.msg = msg;
        state.err_msg = msg;
        return;
      }
      state.msg = msg;
    })
  .addCase(handleOnlineSignatureAcction.rejected, (state, action) => {
      state.pdf = null;
    });
    builder.addCase(submitRequestAction.pending, (state) => {});
    builder.addCase(submitRequestAction.fulfilled, (state, action: PayloadAction<any | null>) => {
      const { result, msg } = action.payload;
      if (!result) {
        const msg =
          action.payload.msg === "Token authorization is failed."
            ? "The seasion has expiried. Please refresh the page or login"
            : action.payload.msg;
        state.err_msg = msg;
        return;
      }
      state.msg = msg;
    });
    builder.addCase(submitRequestAction.rejected, (state, action) => {
      state.pdf = null;
    });
    builder.addCase(generateForm.pending, (state) => {});
    builder.addCase(generateForm.fulfilled, (state, action: PayloadAction<any | null>) => {
      const { result } = action.payload;
      if (!result) {
        const msg =
          action.payload.msg === "Token authorization is failed."
            ? "The seasion has expiried. Please refresh the page or login"
            : action.payload.msg;
        state.err_msg = msg;
        return;
      }

      state.accessToken = action.payload.accessToken;

      state.pdf = action.payload.pdf;
      localStorage.setItem("formToken", action.payload.token);
    });
    builder.addCase(generateForm.rejected, (state, action) => {
      state.pdf = null;
    });

    builder.addCase(docusignAction.fulfilled, (state, action: PayloadAction<any | null>) => {
      const { envelope, envelopId, accessToken } = action.payload.data;
      localStorage.setItem("documentId", envelope.documents[0].documentId);
      localStorage.setItem("envelopeId", envelopId);
      localStorage.setItem("accessToken", accessToken);
      state.msg = "You will now be sent to Docusign to sign your form";
      state.pdf = null;
    });
  },
});
export const { setFormMsg, setFormType, setFormErrMsg } = FormsSlice.actions;

export const selectFormMsg = (state: RootState) => state.FormsSlice.msg;
export const selectPdf = (state: RootState) => state.FormsSlice.pdf;
export const selectErrMsgForm = (state: RootState) => state.FormsSlice.err_msg;
export const selectFormType = (state: RootState) => state.FormsSlice.formType;
export const selectErrors = (state: RootState) => state.FormsSlice.errors;

export default FormsSlice.reducer;